export default __webpack_public_path__ + "static/media/loading-img.76a49c33.gif";